import { AccountController } from "@/app/ui/controllers/AccountController";
import { FlagsMedusa } from "@/feature-flags/flags-misc-medusa";

const SCOPED_COUNTRIES = ["ID", "MY"];

// Master kill-switch epic GENESIS-23074
export const getCountryScopeParam = (): string => {
  if (!FlagsMedusa.permission_hq_country_filter_enable.isEnabled()) {
    return "";
  }
  const account = AccountController.accountData;
  if (!account.isInternalAccount || account.isCustomerService) {
    return "";
  }
  const hqCountry = (account.hqCountry || "").toUpperCase();
  return SCOPED_COUNTRIES.includes(hqCountry) ? hqCountry : "";
};
